import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { PostClassification } from "services/classifications";
import i18next from "i18next";

export default function AddClassifications() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(PostClassification, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم إضافة التصنيف بنجاح"
                : "Classification added successfully",
          });
          queryClient.invalidateQueries("classifications");
        }
      },
    }),
  };
}
